import Payment from "../services/Payment";
import { PaymentProviderAccessorType } from "../services/Payment/types";
import { PaymentAccount } from "../types/PaymentAccount";

export default async function updateBalance(
	account: PaymentAccount,
	providerAccessorId: number,
	providerAccessorType: PaymentProviderAccessorType,
) {
	if (account.isEdited) {
		const toRequest = {
			amount: account.amount,
			description: account.description ?? "",
			paymentAccountId: account.id,
			providerAccessor: {
				id: providerAccessorId,
				type: providerAccessorType,
			},
		};

		const res = await Payment.updateBalance(toRequest);
		return res;
	}

	return false;
}
